<template>
  <IconLucideBookText />
</template>
